<template>
    <div>
        <forms-vue
            v-bind:title="title"
            :form="form"
            v-bind:submit_url="submit_url"
            v-bind:redirect_submit_url="redirect_submit_url"
            v-bind:redirect_submit_url_params="redirect_submit_url_params"
            v-bind:edit_get_url="edit_get_url"
            v-bind:watch="watch"
            v-bind:submit_in_url="submit_in_url"
        />
    </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
    data() {
        return {
            perfil: "administrador",
            formularioValues: {},
            title: "Configuraciones - Usuarios",
            submit_url: this.$route.fullPath + "/save",
            redirect_submit_url: "UsuariosSearch",
            redirect_submit_url_params: {},
            edit_get_url: "",
            submit_in_url: false,
            items: [],
            accesos: [],
            watch: [],
            form: [
                [
                    {
                        col: "12",
                        title: "Datos Generales	",
                        footer: {},
                        attrs: [
                            [
                                {
                                    pretty_name: "Apellido",
                                    name: "apellido",
                                    desc: "select",
                                    type: "text",
                                    cols: "6",
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Nombre",
                                    name: "nombre",
                                    desc: "select",
                                    type: "text",
                                    cols: "6",
                                },
                                {
                                    pretty_name: "Nombre de Usuario",
                                    name: "usua_login",
                                    desc: "select",
                                    type: "text",
                                    cols: "12",
                                },
                                {
                                    pretty_name: "E-Mail",
                                    name: "e_mail",
                                    desc: "select",
                                    type: "text",
                                    cols: "12",
                                },
                                {
                                    pretty_name: "Legajo",
                                    name: "legajo",
                                    desc: "legajo",
                                    type: "text",
                                    cols: "6",
                                },
                                {
                                    pretty_name: "Perfil",
                                    name: "perfil",
                                    desc: "select",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        {
                                            label: "Administrador",
                                            code: "administrador",
                                        },
                                        { label: "Operador", code: "operador" },
                                    ],
                                },
                                {
                                    pretty_name: "Sector",
                                    name: "sector_codigo",
                                    desc: "select",
                                    type: "select",
                                    cols: "6",
                                    options: [],
                                },
                                {
                                    pretty_name: "Estado",
                                    name: "estado",
                                    desc: "select",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        { label: "Activo", code: "A" },
                                        { label: "Dado de baja", code: "B" },
                                    ],
                                },
                                {
                                    pretty_name: "Blanquear contraseña",
                                    name: "resetear_password",
                                    desc: "select",
                                    type: "checkbox",
                                    cols: "12",
                                },
                            ],
                        ],
                        footer: {
                            buttons: [
                                {
                                    type: "button",
                                    text: "Cancelar",
                                    class: "btn btn-danger pull-left",
                                    route: "UsuariosSearch",
                                },
                                {
                                    type: "submit",
                                    text: "Guardar",
                                    class: "btn btn-success pull-right",
                                    route: "UsuariosSearch",
                                },
                            ],
                        },
                    },
                ],
            ],
        };
    },
    created() {
        this.$root
            .Consulta(
                this.$root.UrlBase("configuraciones/sectores/select"),
                {},
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.form[0][0].attrs[0][6].options = response;
            });
        this.$root
            .Consulta(
                this.$root.UrlBase(
                    "configuraciones/usuarios/registros-disponibles"
                ),
                {},
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.form.push(response.registros);
            });
    },
};
</script>
